const getMitigatorState = (state) => state.mitigator;
export const getSeverityList = (state) => {
  const _state = getMitigatorState(state);
  return _state.SeverityList;
};

export const getRiskStatusList = (state) => {
  const _state = getMitigatorState(state);
  return _state.StatusList;
};

export const getCategoryList = (state) => {
  const _state = getMitigatorState(state);
  return _state.CategoryList;
};

export const getDecisionList = (state) => {
  const _state = getMitigatorState(state);
  return _state.DecisionList;
};

export const getRatingsTypes = (state) => {
  const _state = getMitigatorState(state);
  return _state.RatingsTypes;
};
